import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import {
  convertTo12HourFormat,
  formatDateTimezon,
} from "../common-data/Converts";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { deletePTTrack } from "../../redux/reducers/deleteApiSlice";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import PTTrialForm from "./PTTrialForm";
import { BodyBuilder } from "../../exports/Images";
import UserProfile from "./UserProfile";
import ReceptionistForm from "./open-tracks/ReceptionistForm";
import MemberCheckinLogs from "./common/MemberCheckinLogs";
import PTTableCards from "./mobile-view/PTTableCards";
import BackAddBtns from "../Open-pages/target-matrics/common/BackAddBtns";
import { trial_intro_done } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { FutureSubscriptionButton } from "./pt-reports/re-usablee/FutureSubscriptionButton";
import useTableSorting from "../../hooks/useTableSorting";
import { createSortableColumns } from "./PTTrialTableColumns";
import CommonTable from "../common-components/common-tables/CommonTable";
import {
  BinIcon,
  CheckCircleIcon,
  CloudArrowIcon,
  EditIcon,
  EditIcon1,
  XCircleIcon,
} from "../../images/icons/icons";

const PTTrialTable1 = ({
  ptDatas,
  setPTDatas,
  callFunction,
  decryptedText,
  receptionistInfo,
  isAddedByMe,
  addedByMe,
  setAddedByMe,
}) => {
  const dispatch = useDispatch();
  const { isPage, pageLimit, pagination, allPTTracksData } = ptDatas || {};
  const {
    subsPagination,
    handPagination,
    subsIsPage,
    handIsPage,
    trialIsPage,
    trialPagination,
  } = addedByMe || {};
  const isAdmin = decryptedText?.account_type === "admin";
  const isTrainer = decryptedText?.account_type === "trainer";
  const isReceptionist = decryptedText?.account_type === "receptionist";
  const isFitnessManager = decryptedText?.account_type === "fitness_manager";

  const initialClickValues = {
    name: "",
    isModOpen: false,
    rowData: "",
    trainerDetails: {},
    viewImage: "",
    userName: "",
    userNo: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [selectedRows, setSelectedRows] = useState([]);
  const [activePopover, setActivePopover] = useState(null);

  const { handleSort, getSortDirection, isFieldSorted, sortedData } =
    useTableSorting(allPTTracksData || []);

  const iniAdminInfo = {
    name: decryptedText?.name || "",
    mobile: decryptedText?.mobile || "",
    email: decryptedText?.email || "",
    user_id: decryptedText?.uid || "",
    gym_id: decryptedText?.gym_id || "",
    gym_name: decryptedText?.gym_name || "",
    account_type: decryptedText?.account_type || "",
  };

  const handleDelete = async (e, uid) => {
    e.preventDefault();
    if (uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            deletePTTrack({
              TOKEN: decryptedText?.token,
              UID: uid,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
    } else {
      toast.error("UID required!");
    }
  };

  const onClickBtns = (e, name, rowData, formname) => {
    e.preventDefault();

    setClickValues({
      ...clickValues,
      name: name,
      isModOpen: true,
      rowData: rowData,
      trainerDetails: {
        mobile: rowData?.assigned_to_mobile,
        name: rowData?.assigned_to_name,
        gym_name: rowData?.gym_name,
        gym_id: rowData?.gym_id,
        user_id: rowData?.assigned_to,
        email: rowData?.assigned_to_email,
      },
    });
  };

  const onCloseModal = (name) => {
    setClickValues(initialClickValues);
  };

  const handleInfoClick = (rowData, popoverType, event) => {
    if (event) {
      event.stopPropagation();
    }
    const popoverId = `${rowData.uid}-${popoverType}`;
    setActivePopover(activePopover === popoverId ? null : popoverId);
  };

  const handleTrialIntroUpdate = async (requestBody) => {
    const method = "POST";
    const endpoint = trial_intro_done;
    const payload = requestBody;
    const token = decryptedText?.token;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        callFunction();
        setSelectedRows([]);
        setPTDatas((prevState) => ({
          ...prevState,
          allPTTracksData: prevState.allPTTracksData.map((lead) => ({
            ...lead,
            checked: false,
          })),
        }));
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  function onClickTrialDone() {
    const allTrailsIntros = selectedRows?.map((row) => row?.uid);

    const userData = {
      trial_details: allTrailsIntros,
    };

    const handleConfirm = async () => {
      handleTrialIntroUpdate(userData);
    };

    showConfirmAlert(handleConfirm, `Are You Sure?`);
  }

  const sortableColumns = createSortableColumns({
    handleSort,
    getSortDirection,
    isFieldSorted,
    handleInfoClick,
    setClickValues,
    onClickBtns,
    handleDelete,
    activePopover,
    setActivePopover,
    isTrainer,
    isAdmin,
    isFitnessManager,
    isReceptionist,
  });

  const tbColumns = [
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="tb-buttons  ">
          {row?.is_future_subscription ? (
            <FutureSubscriptionButton row={row} />
          ) : (
            <>
              <button
                className="icon-btn edit"
                onClick={(e) =>
                  (row?.trial_status === "completed" ||
                    row?.trial_status === "converted" ||
                    row?.trial_status?.includes("cnvrtd")) &&
                  (isTrainer || isAdmin || isFitnessManager)
                    ? onClickBtns(e, "edit-pt-trial", row, "pt_trial")
                    : row?.handover_status === "completed" &&
                      (isReceptionist || isAdmin || isFitnessManager)
                    ? onClickBtns(e, "edit-handover", row, "handover")
                    : null
                }
                disabled={
                  (row?.trial_status !== "completed" ||
                    row?.trial_status !== "converted") &&
                  row?.handover_status !== "completed"
                }
                style={{
                  cursor:
                    row?.trial_status === "completed" ||
                    row?.trial_status === "converted" ||
                    row?.handover_status === "completed"
                      ? "pointer"
                      : "not-allowed",
                }}
              >
                <EditIcon1
                  color={
                    row?.trial_status === "pending" &&
                    row?.handover_status === "pending"
                      ? "gray"
                      : "#000"
                  }
                />
              </button>

              {isAdmin ? (
                <button
                  className="icon-btn delete"
                  onClick={(e) =>
                    row?.trial_status !== "pending" && handleDelete(e, row?.uid)
                  }
                  disabled={row?.trial_status === "pending"}
                  style={{
                    cursor:
                      row?.trial_status === "pending"
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  <BinIcon
                    color={row?.trial_status === "pending" ? "gray" : "#000"}
                  />
                </button>
              ) : null}

              {row?.handover_status === "pending" &&
              (isReceptionist || isAdmin || isFitnessManager) ? (
                <button
                  type="button"
                  className="tb-btn initiate-handover"
                  onClick={(e) => onClickBtns(e, "initiate-handover", row)}
                >
                  Initiate Handover
                </button>
              ) : row?.handover_status !== "pending" &&
                row?.trial_status === "pending" &&
                (isTrainer || isAdmin || isFitnessManager) ? (
                <button
                  type="button"
                  className="tb-btn initiate-handover"
                  onClick={(e) => onClickBtns(e, "initate-pt-trial", row)}
                >
                  Start PT Trial
                </button>
              ) : null}
            </>
          )}
        </div>
      ),
    },
    {
      dataField: "user_name",
      text: "Member",
      formatter: (_, row) => (
        <div
          className="emeberDetailsRowContainer"
          style={{
            textAlign: "center",
            justifyContent: "flex-start",
            gap: "1rem",
          }}
        >
          <span
            className="tb-data tb-link"
            style={{
              textAlign: "start",
            }}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                rowData: row,
                isModOpen: true,
                name: "userDetailsModal",
              }))
            }
          >
            {row?.user_name?.replace(/_/g, " ") || "NA"}
            <br />
          </span>
        </div>
      ),
    },
    !isReceptionist && {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "handover_status",
      text: "Handover Status",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.handover_status === "handover_completed" ||
            row?.handover_status === "completed" ||
            row?.handover_status === "handover_converted" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "trial_status",
      text: "Trial Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data maxWidth120 withPadding borderRdius8"
            style={{
              background:
                row?.trial_status === "converted" ||
                row?.trial_status === "trial_done_cnvrtd"
                  ? "#E2EFD5"
                  : row?.trial_status === "completed"
                  ? "#FFEDC0"
                  : "#F3DADA",
              color:
                row?.trial_status === "converted" ||
                row?.trial_status === "trial_done_cnvrtd"
                  ? "#379C00"
                  : row?.trial_status === "completed"
                  ? "#171717"
                  : "#D90000",
              borderRadius: "9999px",
              textAlign: "center",
              padding: "5px 10px",
            }}
          >
            {row?.trial_status === "completed"
              ? "Completed (Not Converted)"
              : row?.trial_status === "trial_done_cnvrtd"
              ? "PT consultation done And Converted"
              : row?.trial_status === "trial_notdone_cnvrtd"
              ? "PT consultation not done And Converted"
              : row.trial_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "assigned_by_name",
      text: "Handover From",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">{row?.assigned_by_name || "NA"}</span>

            {row?.assigned_by_mobile && (
              <span className="tb-data">{row?.assigned_by_mobile || ""}</span>
            )}

            {row?.assigned_by_email && (
              <span className="tb-data lowercase">
                {row?.assigned_by_email || ""}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "assigned_to_name",
      text: "Assigned To (Trainer)",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">{row?.assigned_to_name || "NA"}</span>

            {row?.assigned_to_mobile && (
              <span className="tb-data">
                {row?.assigned_to_mobile || ""}
              </span>
            )}

            {row?.assigned_to_email && (
              <span className="tb-data lowercase">
                {row?.assigned_to_email || ""}
              </span>
            )}
          </div>
        );
      },
    },
    // {
    //   dataField: "sub_added_by_name",
    //   text: "Subscription Added By",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data maxWidth150">
    //         {row?.sub_added_by_name || "NA"}
    //       </span>
    //     );
    //   },
    // },
    ...sortableColumns,
    {
      dataField: "three_day_assigned",
      text: "3 Day Trial",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data tb-icon">
              {row?.hree_day_assigned ? <CheckCircleIcon /> : <XCircleIcon />}
            </span>
            <span className="tb-data">
              {row?.threeday_start_date
                ? formatDateTimezon(row.threeday_start_date)
                : "-"}{" "}
              -{" "}
              {row?.threeday_expire_date
                ? formatDateTimezon(row.threeday_expire_date)
                : "-"}
            </span>
            {(row?.threeday_slot_start || row?.threeday_slot_end) && (
              <span className="tb-data">
                {row?.threeday_slot_start
                  ? convertTo12HourFormat(row.threeday_slot_start)
                  : "-"}{" "}
                -{" "}
                {row?.threeday_slot_end
                  ? convertTo12HourFormat(row.threeday_slot_end)
                  : "-"}
              </span>
            )}
          </div>
        );
      },
    },
  ];

  const tbColumnsTrainer = [
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="tb-buttons">
          {row?.is_future_subscription ? (
            <FutureSubscriptionButton row={row} />
          ) : (
            <>
              <button
                className="icon-btn edit"
                onClick={(e) =>
                  row?.trial_status !== "pending" && (isAdmin || isTrainer)
                    ? onClickBtns(e, "edit-pt-trial", row, "pt_trial")
                    : null
                }
                disabled={row?.trial_status === "pending"}
                style={{
                  cursor:
                    row?.trial_status === "pending" ? "not-allowed" : "pointer",
                }}
              >
                <EditIcon
                  color={
                    row?.trial_status === "pending" &&
                    row?.handover_status === "pending"
                      ? "gray"
                      : "#000"
                  }
                />
              </button>

              {row?.handover_status !== "pending" &&
              row?.trial_status === "pending" &&
              (isTrainer || isAdmin || isFitnessManager) ? (
                <button
                  type="button"
                  className="tb-btn initiate-handover"
                  onClick={(e) => onClickBtns(e, "initate-pt-trial", row)}
                >
                  Start PT Trial
                </button>
              ) : null}
            </>
          )}
        </div>
      ),
    },
    {
      dataField: "user_name",
      text: "Member",
      formatter: (_, row) => (
        <div
          className="emeberDetailsRowContainer"
          style={{
            textAlign: "center",
            justifyContent: "flex-start",
            gap: "1rem",
          }}
        >
          <img
            src={row?.user_profile || BodyBuilder}
            alt={row?.user_name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
            }}
            onClick={() => {
              setClickValues({
                isModOpen: true,
                name: "imageModal",
                viewImage: row?.user_profile || BodyBuilder,
                userName: row?.user_name || "",
                userNo: row?.user_mobile || "",
              });
            }}
          />
          <span
            className="tb-data link minWidth150"
            style={{
              textAlign: "start",
            }}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                rowData: row,
                isModOpen: true,
                name: "userDetailsModal",
              }))
            }
          >
            {row?.user_name?.replace(/_/g, " ") || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        </div>
      ),
    },
    {
      dataField: "bca_report_status",
      text: "BCA Report",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.bca_report_status === "completed" ? (
              <a href={row?.bca_report}>
                <CloudArrowIcon />
              </a>
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "assigned_by_name",
      text: "Handover From",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.assigned_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.assigned_by_mobile || ""}
              <br />
              {row?.assigned_by_email || ""}
            </small>
          </span>
        );
      },
    },
    ...sortableColumns,
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Trial Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            clickValues.name === "prospect_reason"
              ? "width50vw"
              : clickValues.name === "imageModal"
              ? "image-modal"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${
              clickValues.name === "initiate-handover"
                ? "Initiate Handover"
                : clickValues.name === "initate-pt-trial"
                ? "Register PT Trial"
                : clickValues.name === "edit-pt-trial"
                ? "Edit PT Trial Info"
                : clickValues.name === "edit-handover"
                ? "Edit Handover"
                : clickValues.name === "userDetailsModal"
                ? "Member Profile"
                : clickValues.name === "imageModal"
                ? clickValues.userName + "/" + clickValues.userNo
                : clickValues.name === "prospect_reason"
                ? "Reason For Non PT Prospect"
                : clickValues.name === "checkinLogsModal"
                ? clickValues.type + " Checkin Logs"
                : clickValues.name?.replace(/_/g, " ")
            }`}
            onClose={onCloseModal}
          />

          {clickValues.name === "initiate-handover" ? (
            <ReceptionistForm
              name={clickValues.name}
              closeModal={onCloseModal}
              decryptedText={decryptedText}
              callFunction={callFunction}
              rowData={clickValues.rowData}
              receptionistInfo={isAdmin ? iniAdminInfo : receptionistInfo}
            />
          ) : clickValues.name === "initate-pt-trial" ? (
            <PTTrialForm
              name={"initiate-handover"}
              trainerInfo={clickValues.trainerDetails}
              closeModal={onCloseModal}
              decryptedText={decryptedText}
              callFunction={callFunction}
              rowData={clickValues.rowData}
            />
          ) : clickValues.name === "edit-pt-trial" ? (
            <PTTrialForm
              closeModal={() => onCloseModal}
              callFunction={callFunction}
              name={"edit"}
              rowData={clickValues.rowData}
              trainerInfo={clickValues.trainerDetails}
              decryptedText={decryptedText}
            />
          ) : clickValues.name === "edit-handover" ? (
            <ReceptionistForm
              name={"edit"}
              closeModal={() => onCloseModal}
              decryptedText={decryptedText}
              callFunction={callFunction}
              rowData={clickValues.rowData}
              receptionistInfo={isAdmin ? iniAdminInfo : receptionistInfo}
            />
          ) : clickValues.name === "userDetailsModal" ? (
            <UserProfile userData={clickValues.rowData} />
          ) : clickValues.name === "imageModal" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={clickValues.viewImage}
                alt="profile"
                style={{
                  width: "90%",
                  height: "90%",
                  objectFit: "contain",
                }}
              />
            </div>
          ) : clickValues.name === "prospect_reason" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {clickValues.remarks || "No Content Available"}
              </p>
            </div>
          ) : clickValues.name === "checkinLogsModal" ? (
            <MemberCheckinLogs clickValues={clickValues} sendableStatsQPs="" />
          ) : null}
        </div>
      </Modal>

      {selectedRows?.length > 0 && (
        <div className="mt30">
          <BackAddBtns
            isRawLead={true}
            addBtnTxt={`${
              selectedRows?.length === 0
                ? "Select Rows From The Table"
                : "Trial Intro Done"
            }`}
            onClickAdd={onClickTrialDone}
            onClickReload={() => {
              callFunction();
              setSelectedRows([]);
              setPTDatas((prevState) => ({
                ...prevState,
                allPTTracksData: prevState.allPTTracksData.map((lead) => ({
                  ...lead,
                  checked: false,
                })),
              }));
            }}
            isAddBtn={true}
            isDiabled={selectedRows?.length === 0}
          />
        </div>
      )}

      <div className="common-table-container mt15 hideMobile separate-table">
        <CommonTable
          tableData={sortedData}
          tableColumns={isTrainer ? tbColumnsTrainer : tbColumns}
          tablePagination={
            isAddedByMe === "subs_added_by_me"
              ? subsPagination
              : isAddedByMe === "hand_added_by_me"
              ? handPagination
              : isAddedByMe === "trial_initiated_by_me"
              ? trialPagination
              : pagination
          }
          isPage={
            isAddedByMe === "subs_added_by_me"
              ? subsIsPage
              : isAddedByMe === "hand_added_by_me"
              ? handIsPage
              : isAddedByMe === "trial_initiated_by_me"
              ? trialIsPage
              : isPage
          }
          setIsPage={(value) =>
            isAddedByMe === "subs_added_by_me"
              ? setAddedByMe((prevs) => ({ ...prevs, subsIsPage: value }))
              : isAddedByMe === "hand_added_by_me"
              ? setAddedByMe((prevs) => ({ ...prevs, handIsPage: value }))
              : isAddedByMe === "trial_initiated_by_me"
              ? setAddedByMe((prevs) => ({ ...prevs, trialIsPage: value }))
              : setPTDatas((prevData) => ({
                  ...prevData,
                  isPage: value,
                }))
          }
          pageLimit={!isAddedByMe && pageLimit}
          setPageLimit={(value) =>
            !isAddedByMe &&
            setPTDatas((prevData) => ({
              ...prevData,
              pageLimit: value,
            }))
          }
        />
      </div>

      <div className="lead-logs-card-container pt-trial-tb-cards only-mobile">
        <PTTableCards
          tableData={sortedData}
          setClickValues={setClickValues}
          tablePagination={
            isAddedByMe === "subs_added_by_me"
              ? subsPagination
              : isAddedByMe === "hand_added_by_me"
              ? handPagination
              : isAddedByMe === "trial_initiated_by_me"
              ? trialPagination
              : pagination
          }
          isPage={
            isAddedByMe === "subs_added_by_me"
              ? subsIsPage
              : isAddedByMe === "hand_added_by_me"
              ? handIsPage
              : isAddedByMe === "trial_initiated_by_me"
              ? trialIsPage
              : isPage
          }
          setIsPage={(value) =>
            isAddedByMe === "subs_added_by_me"
              ? setAddedByMe((prevs) => ({ ...prevs, subsIsPage: value }))
              : isAddedByMe === "hand_added_by_me"
              ? setAddedByMe((prevs) => ({ ...prevs, handIsPage: value }))
              : isAddedByMe === "trial_initiated_by_me"
              ? setAddedByMe((prevs) => ({ ...prevs, trialIsPage: value }))
              : setPTDatas((prevData) => ({
                  ...prevData,
                  isPage: value,
                }))
          }
          onClickBtns={onClickBtns}
          handleDelete={handleDelete}
          userInfoData={decryptedText}
        />
      </div>
    </>
  );
};

export default PTTrialTable1;
